import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=553b692a&scoped=true"
import script from "./appoint.vue?vue&type=script&lang=js"
export * from "./appoint.vue?vue&type=script&lang=js"
import style0 from "./appoint.vue?vue&type=style&index=0&id=553b692a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b692a",
  null
  
)

export default component.exports